import initUnits from "utils/units_conversion"

import polyfill from "./polyfill"
import stickyElements from "./javascript/sticky"
import signUp from "./javascript/signup"
import visualReport from "./javascript/visual-report"
import modalFeedback from "./javascript/modal-feedback"
import countdown from "./javascript/countdown"
import readMore from "./javascript/read-more"
import clipboard from "./javascript/clipboard"
import infoTooltip from "./javascript/info-tooltip"

export default function init() {
  polyfill()
  initUnits()
  stickyElements()
  signUp()
  visualReport()
  modalFeedback()
  countdown()
  readMore()
  clipboard()
  infoTooltip()
}
